import "css!js/file_viewer/preview_text/preview_text.module.out.css";
export const scrollableContainer = "_scrollableContainer_t4qxl_1";
export const block = "_block_t4qxl_7";
export const lineContainer = "_lineContainer_t4qxl_11";
export const noLineNumber = "_noLineNumber_t4qxl_28";
export const lineContent = "_lineContent_t4qxl_32";
export const spinnerContainer = "_spinnerContainer_t4qxl_37";
export const gray = "_gray_t4qxl_45";
export const green = "_green_t4qxl_49";
export const blue = "_blue_t4qxl_53";
export const red = "_red_t4qxl_57";
export const base = "_base_t4qxl_61";
const classes = { "scrollableContainer": "_scrollableContainer_t4qxl_1", "block": "_block_t4qxl_7", "lineContainer": "_lineContainer_t4qxl_11", "noLineNumber": "_noLineNumber_t4qxl_28", "lineContent": "_lineContent_t4qxl_32", "spinnerContainer": "_spinnerContainer_t4qxl_37", "gray": "_gray_t4qxl_45", "green": "_green_t4qxl_49", "blue": "_blue_t4qxl_53", "red": "_red_t4qxl_57", "base": "_base_t4qxl_61" };
export default classes;
//# sourceMappingURL=preview_text.module.css.preenvesnextjs.map
